module.exports = __webpack_public_path__ + "static/media/social.2ad21bba.jpg";